import React, { useCallback, useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";

import { useToast } from "hooks/toast";
import { listProdutos, definirProdutos } from "services/onboardingApi";

const DESCRICOES = {
  FLOW: "Base: TMS / Hub, cálculo e auditoria de frete",
  AUTOPILOT: "Automação e auditoria de faturas e CT-e",
  GOBID: "Cotação e leilão de frete",
  TRACKFY: "Rastreamento de entregas",
};

// Produto/Plano contratado (PO1-2529). FLOW é a base, sempre incluso; os
// demais módulos gateiam defaults da Configuração automática (H2/H5).
export default function ProdutoStep({ idEmbarcador, onSaved }) {
  const { addToast } = useToast();
  const [catalogo, setCatalogo] = useState([]);
  const [base, setBase] = useState("FLOW");
  const [selecionados, setSelecionados] = useState(new Set());
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const dados = await listProdutos(idEmbarcador);
        setCatalogo(dados.catalogo || []);
        setBase(dados.base || "FLOW");
        setSelecionados(new Set(dados.ativos || []));
      } catch (err) {
        console.error("[ProdutoStep] listProdutos:", err);
        addToast({
          place: "tr",
          type: "danger",
          title: "Erro ao carregar produtos",
          icon: "tim-icons icon-alert-circle-exc",
        });
      } finally {
        setCarregando(false);
      }
    })();
  }, [idEmbarcador, addToast]);

  const toggle = useCallback(
    (codigo) => {
      if (codigo === base) return;
      setSelecionados((prev) => {
        const next = new Set(prev);
        if (next.has(codigo)) {
          next.delete(codigo);
        } else {
          next.add(codigo);
        }
        return next;
      });
    },
    [base]
  );

  const handleSalvar = useCallback(async () => {
    setSalvando(true);
    try {
      await definirProdutos(idEmbarcador, Array.from(selecionados));
      addToast({
        place: "tr",
        type: "success",
        title: "Produto/Plano salvo",
        icon: "tim-icons icon-check-2",
      });
      onSaved();
    } catch (err) {
      const msg =
        (err.response && err.response.data && err.response.data.error) ||
        err.message;
      addToast({
        place: "tr",
        type: "danger",
        title: "Erro ao salvar produtos",
        description: msg,
        icon: "tim-icons icon-alert-circle-exc",
      });
    } finally {
      setSalvando(false);
    }
  }, [idEmbarcador, selecionados, addToast, onSaved]);

  if (carregando) {
    return <Spinner size="sm" />;
  }

  return (
    <div>
      {catalogo.map((produto) => {
        const isBase = produto.codigo === base;
        const marcado = isBase || selecionados.has(produto.codigo);
        return (
          <div className="onb-filial" key={produto.codigo}>
            <div className="d-flex align-items-start" style={{ gap: 12 }}>
              <input
                type="checkbox"
                checked={marcado}
                disabled={isBase}
                onChange={() => toggle(produto.codigo)}
                style={{ width: 18, height: 18, marginTop: 3 }}
              />
              <div>
                <div className="nm">{produto.nome || produto.codigo}</div>
                <div className="ci">
                  {DESCRICOES[produto.codigo] || produto.codigo}
                </div>
              </div>
            </div>
            {isBase && <span className="onb-badge done">sempre incluso</span>}
          </div>
        );
      })}

      <div className="onb-info">
        <span role="img" aria-label="informação">ℹ️</span>
        <span>
          O produto liga os documentos e parâmetros correspondentes na{" "}
          <b>Configuração automática</b>. Ex.: Autopilot habilita os gates de
          fatura/CT-e.
        </span>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <Button color="primary" onClick={handleSalvar} disabled={salvando}>
          {salvando ? <Spinner size="sm" /> : "Salvar"}
        </Button>
      </div>
    </div>
  );
}
